import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

//Import Buefy components
import './plugins/buefy'

//Import Axios components
import './plugins/axios'

//Import leaflet
import './plugins/leaflet'
import moment from 'moment'
import VueFuse from 'vue-fuse'

Vue.use(VueFuse)

Vue.config.productionTip = false
moment.locale('fr')
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      next({
        name: 'Jobsite',
      })
    }  else {
      next()
    }
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
